import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X, ArrowUpRight } from "@phosphor-icons/react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  const links = [
    { href: "#categories", label: "Categories" },
    { href: "#about", label: "About" },
    { href: "#social", label: "Social" },
    { href: "#contact", label: "Partner" },
  ];

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/65 backdrop-blur-2xl border-b border-slate-200/70" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="font-display font-bold tracking-tight text-base md:text-[17px]">
            HANGANG<span className="text-[#FF6B9E]">.</span>GLOBAL
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[13px] font-medium tracking-wide hover:text-[#FF6B9E] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <NavLink
            to="/admin/login"
            data-testid="nav-admin"
            className="inline-flex items-center gap-1.5 text-[11px] tracking-[0.22em] uppercase font-medium border border-slate-900 rounded-full px-4 py-2 hover:bg-[#0F172A] hover:text-white transition-colors"
          >
            Admin <ArrowUpRight size={12} weight="bold" />
          </NavLink>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 rounded-full border border-[#0F172A]"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={18} weight="bold" /> : <List size={18} weight="bold" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-white/60 px-5 py-5 flex flex-col gap-4">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-base font-medium py-1.5">
              {l.label}
            </a>
          ))}
          <NavLink to="/admin/login" data-testid="nav-mobile-admin" className="sticker self-start">
            Admin
          </NavLink>
        </div>
      )}
    </header>
  );
}
